import styled from '@emotion/styled';

const ManagerWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export default ManagerWrapper;
